<template>
    <div class="modalwrapper accromacontrols">
        <h1>Assign Project/Workflow</h1>
        <treeselect placeholder="Select project..." :async="true" :load-options="loadOptionsProject" v-model="selectedProject" :defaultOptions="true"/>
        <br>
        <WorkflowSelector v-model="selectedWorkflow" :vialType="slots[0].vialType"/>
        <br>
        <div class="nettoWeights">
            <table>
                <tr>
                    <th>Slot</th>
                    <th>Name</th>
                    <th>Netto weight</th>
                </tr>
                <tr v-for="slot in slots">
                    <td>{{cleanName(slot.slot)}}</td>
                    <td>{{slot.name}}</td>
                    <td>
                        <vue-numeric
                            v-model="slot.nettoWeight"
                            thousand-separator="'" 
                            :precision="4" 
                            :min="0" 
                            :max="100" 
                            currency="g"
                            currency-symbol-position="suffix" 
                            decimal-separator="." 
                        />
                    </td>
                </tr>
            </table>
        </div>
        <br>
        <button @click="assign">{{selectedProject?'Assign':'Cancel'}}</button>
    </div>
</template>

<script>
import WorkflowSelector from './WorkflowSelector';

export default {
    methods: {
        loadOptionsProject({ action, searchQuery, callback }){
            console.log({ action, searchQuery, callback })
            callback(null, [{
                label: searchQuery.length?'Create '+searchQuery:'Type to create',
                id: searchQuery
            }, ...this.$store.state.projects.map(p=>({id:p, label:p, key:p}))]);
        },
        addTag(newTag){
            this.$store.state.projects.push(newTag);
            this.selectedProject = newTag;
        },
        assign(){
            if(!this.selectedProject){
                this.selectedWorkflow = null;
            }
            else
            {
                this.selectedProject = this.selectedProject || '';
                this.selectedWorkflow = this.selectedWorkflow || '';

                this.slots.forEach((slot, index)=>{
                    slot.project = this.selectedProject;
                    slot.workflowName = this.selectedWorkflow;
                }) 
            }

            this.close();
            this.$emit('close');
        },
        cleanName(name){
            return name.match(/slot(.*$)/)[1];
        },
    },

    components: {
        WorkflowSelector,
    },
    mounted(){
        if (this.slots.every((val, i, arr) => val.project === this.slots[0].project) && this.slots[0].project != '') {
            this.selectedProject = this.slots[0].project;
        }

    },
    props: [
        'close',
        'slots',
    ],
    data: function(){
        return {
            newProjects:[
                {
                    id: '',
                    label: 'Type to create'
                },
            ],
            selectedProject: null,
            selectedWorkflow: null,
        }
    }
}

</script>

<style lang="scss" scoped>
    @import "../colors.scss";
    .modalwrapper {
        padding: 10px;
    }
    .padding {
        padding-bottom: 10px;
    }
    .con {
        padding: 10px;
    }
    .nettoWeights {
        height: 240px;
        overflow-y: scroll;
        position: relative;
        table {
            th {
                background-color: #fff;
                position: sticky;
                top: 0;
                z-index: 10;
            }
        }
    }
</style>
